module.exports = __webpack_public_path__ + "img/03-illu-kafu2021.990201c2.png";